import types from './types';

const InitialState = {
    loaded: false,
    tasks: null
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.update.one:
            return {
                ...state,
                tasks: {
                    ...state.tasks,
                    [payload.type]: {
                        ...state.tasks[payload.type],
                        [payload.task]: {
                            ...payload.data,
                            timestamp: payload.data.timestamp ? Date.now() + payload.data.timestamp : null
                        }
                    }
                }
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                tasks: {
                    general: payload.general,
                    daily: {
                        ...payload.daily,
                        deposit: {
                            ...payload.daily.deposit,
                            timestamp: Date.now() + payload.daily.deposit.timestamp
                        },
                        deposit_crypto: {
                            ...payload.daily.deposit,
                            timestamp: Date.now() + payload.daily.deposit.timestamp
                        },
                        vip_deposit: {
                            ...payload.daily.vip_deposit,
                            timestamp: Date.now() + payload.daily.vip_deposit.timestamp
                        },
                        games: {
                            ...payload.daily.games,
                            timestamp: Date.now() + payload.daily.games.timestamp
                        },
                        facebook: {
                            ...payload.daily.facebook,
                            timestamp: payload.daily.facebook.timestamp ? Date.now() + payload.daily.facebook.timestamp : 0
                        },
                        facebook_story: {
                            ...payload.daily.facebook_story,
                            timestamp: payload.daily.facebook_story.timestamp ? Date.now() + payload.daily.facebook_story.timestamp : 0
                        }
                    },
                    weekly: {
                        ...payload.weekly
                    }
                }
            }
        default:
            return state;
    }
}